import { render, staticRenderFns } from "./type_2.vue?vue&type=template&id=31e5d9fc&scoped=true"
import script from "./type_2.vue?vue&type=script&lang=js"
export * from "./type_2.vue?vue&type=script&lang=js"
import style0 from "./type_2.vue?vue&type=style&index=0&id=31e5d9fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e5d9fc",
  null
  
)

export default component.exports